import { Fragment } from 'react';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import { FormatMoneyWithSymbol } from '@usas/ui-web/utils/FormatMoney';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeDetailTableRow = ({ purchaseItemDetail, onDeletePurchaseItemDetailClicked }) => {
  return (
    <tr>
      <td>{purchaseItemDetail.itemDescription || ''}</td>
      <td>{purchaseItemDetail.itemPrice >= 0 ? FormatMoneyWithSymbol(purchaseItemDetail.itemPrice) : ''}</td>
      <td>{purchaseItemDetail.canBeDeleted === true && <button className={global.IconButtonMargin}
        type="button"
        onClick={(e) => onDeletePurchaseItemDetailClicked(e, purchaseItemDetail)}>
        <DeleteIcon />
      </button>}</td>
    </tr>
  )
}

const LargeDetailTable = ({ purchaseItem, onDeletePurchaseItemDetailClicked }) => {
  return (
    <table className={global.DetailTable}>
      <thead>
        <tr>
          <th>Item Description</th>
          <th>Item Price</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(purchaseItem.purchaseItemDetails) && purchaseItem.purchaseItemDetails.length > 0 &&
          purchaseItem.purchaseItemDetails.map((purchaseItemDetail, i) =>
            <LargeDetailTableRow
              purchaseItemDetail={purchaseItemDetail}
              onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
              key={i}
            />)}
      </tbody>
    </table>
  );
};

const GridRow = ({ purchaseItem, onClick, expandedId, onDeletePurchaseItemDetailClicked }) => {
  return (
    <Fragment>
      <tr key={`${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}`}>
        <td>{purchaseItem.omeFeeTypeName || ''}</td>
        <td>{purchaseItem.amount !== null && purchaseItem.amount > 0 ? '$' + purchaseItem.amount.toFixed(2) : '$0.00'}</td>
        <td>{purchaseItem.quantity !== null && purchaseItem.quantity >= 0 ? purchaseItem.quantity : '0'}</td>
        <td>{purchaseItem.totalAmount !== null && purchaseItem.totalAmount > 0 ? '$' + purchaseItem.totalAmount.toFixed(2) : '$0.00'}</td>
        <td> {Array.isArray(purchaseItem.purchaseItemDetails) && purchaseItem.purchaseItemDetails.length > 0 &&
          <button
            className={global.IconButtonMargin}
            type="button"
            onClick={(e) => onClick(e, `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}`)}>
            {expandedId === `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}` ? <HideIcon /> : <ShowIcon />}
          </button>}</td>
      </tr>
      {expandedId === `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}` && Array.isArray(purchaseItem.purchaseItemDetails) && purchaseItem.purchaseItemDetails.length > 0 &&
        <tr className={global.Expanded}>
          <td colSpan="5">
            <LargeDetailTable purchaseItem={purchaseItem} onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked} />
          </td>
        </tr>}
    </Fragment>
  );
};

const OrgUnitAdminPurchasesLargeGrid = ({ gridData, isLoading, onClick, expandedId, onDeletePurchaseItemDetailClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Line Item</th>
        <th style={{ minWidth: '110px' }}>Line Item Cost</th>
        <th>Quantity</th>
        <th style={{ minWidth: '90px' }}>Total Cost</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan="5">Loading...</td></tr>
        : Array.isArray(gridData) && gridData?.length > 0 ?
          gridData?.map((purchaseItem, i) =>
            <GridRow
              key={i}
              purchaseItem={purchaseItem}
              onClick={onClick}
              expandedId={expandedId}
              onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
            />)
          :
          <tr>
            <td colSpan={5}>No Purchases</td>
          </tr>
      }
    </tbody>
  </table>
);

export default OrgUnitAdminPurchasesLargeGrid;